<template>
	<!--
		Prospetto a righe (riepilogo e conto economico): voce, importo, confronto.
		rows: [{ label, value, previous, total (riga di totale), negative (si mostra in sottrazione),
		         indent, hint, badge: { text, color } }]
	-->
	<div class="fs">
		<div class="fs-row fs-head">
			<div class="fs-label"></div>
			<div class="fs-value">{{ currentLabel }}</div>
			<template v-if="compare">
				<div class="fs-value">{{ previousLabel }}</div>
				<div class="fs-delta">Var.</div>
			</template>
		</div>
		<div v-for="row in rows" :key="row.label" class="fs-row" :class="{ 'fs-total': row.total, 'fs-indent': row.indent }">
			<div class="fs-label">
				{{ row.label }}
				<v-chip v-if="row.badge" x-small label outlined :color="row.badge.color" class="ml-1">{{ row.badge.text }}</v-chip>
				<v-tooltip v-if="row.hint" bottom max-width="320">
					<template v-slot:activator="{ on }">
						<v-icon x-small class="ml-1" color="grey" v-on="on">mdi-information-outline</v-icon>
					</template>
					<span>{{ row.hint }}</span>
				</v-tooltip>
			</div>
			<div class="fs-value" :class="valueClass(row, row.value)">{{ money(row, row.value) }}</div>
			<template v-if="compare">
				<div class="fs-value grey--text text--darken-1">{{ money(row, row.previous) }}</div>
				<div class="fs-delta">
					<span :class="`${deltaColor(change(row), row.negative)}--text`">{{ formatDelta(change(row)) }}</span>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import { formatEurCents, formatDelta, deltaColor } from './format';

export default {
	name: 'FinanceStatement',
	props: {
		rows: { type: Array, required: true },
		compare: { type: Boolean, default: false },
		currentLabel: { type: String, default: 'Periodo' },
		previousLabel: { type: String, default: 'Confronto' },
	},
	methods: {
		formatDelta,
		deltaColor,
		money(row, value) {
			if (value === null || value === undefined) return '—';
			const v = +value || 0;
			return formatEurCents(row.negative && v ? -v : v);
		},
		valueClass(row, value) {
			return { 'red--text text--darken-1': !row.total && ((row.negative && +value) || +value < 0) };
		},
		change(row) {
			const a = +row.value || 0;
			const b = +row.previous || 0;
			if (b === 0) return a === 0 ? 0 : null;
			return Math.round(((a - b) / Math.abs(b)) * 1000) / 10;
		},
	},
};
</script>

<style scoped>
.fs-row {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 4px;
	border-bottom: 1px solid #eef1f5;
	font-size: 14px;
}
.fs-head {
	font-size: 12px;
	color: #5f6b7a;
	border-bottom: 1px solid #e1e7ef;
}
.fs-label {
	flex: 1;
	min-width: 0;
}
.fs-value {
	width: 140px;
	text-align: right;
	white-space: nowrap;
}
.fs-delta {
	width: 70px;
	text-align: right;
	font-size: 12px;
}
.fs-total {
	font-weight: 600;
	background: #f7f9fc;
}
.fs-indent .fs-label {
	padding-left: 16px;
	color: #5f6b7a;
}
@media (max-width: 600px) {
	.fs-value {
		width: 100px;
	}
	.fs-delta {
		display: none;
	}
}
</style>
